module.exports = __webpack_public_path__ + "img/empty-cart.9cfd158e.png";